import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable, Subject, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { service_methods6 } from '../admin/service_methods6';

@Injectable({
  providedIn: 'root'
})

export class AuthguardGuard implements CanActivate {
  menulist = new Subject<[]>();
  constructor(private obj: service_methods6, private http: HttpClient, private router: Router) {

  }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.isexits(state.url);
  }

  async isexits(routerlinkpage): Promise<boolean> {
    var nb = "";
    var flag;
    [...routerlinkpage].forEach(c => {
      nb = nb + c.toString().charCodeAt(0)
    });

    await this.obj._commonget("validate_page_access?route=" + routerlinkpage + "").then(data => {
      if (data[0].success > 0) {
        flag = true;
      }
      else {
        flag = false;
        this.router.navigate(['v/dashboard/home']);
      }
    })
    return flag;
    // var menus = JSON.parse(localStorage.getItem("loginid"));
    // if (menus.includes(routerlinkpage)) {
    //   return true
    // }
    // else {
    //   return false;
    // }

  }
  async bindmenus() {
    await this.obj._commonget("menu_checkmenu").then((data) => {
      return of(data)
    })

  }
  isLoggedIn(url): Observable<any> {
    alert(url)
    return this.http.get(environment.apiurl6 + "menu_checkmenu?url=" + url + "");
  }
}
